import { Input, Button, Form, Select } from "antd";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { addBodySize, modifyBodySize } from "./bodySizeSlice";
import { CommonContext, CommonContextType } from "../../contexts/CommonContext";
import { useSelector } from "react-redux";
import { AppState } from "../../redux/store/rootReducer";

export default function AddBodySize(): JSX.Element {
  const dispatch = useDispatch();
  const { setModelChange, messageApi, editBodySize, setEditBodySize } =
    React.useContext(CommonContext) as CommonContextType;
  const NutsData = useSelector((state: AppState) => state.Nuts);
  const [form] = Form.useForm();
  const [nut_array, setNutArray] = useState([{}]);

  React.useEffect(() => {
    if (NutsData.Nut.length > 0) {
      const arr = NutsData.Nut.map((el: any) => ({ value: el.id, label: el.nut_name }))
      setNutArray(arr);
    }

    if (editBodySize?.bodysize_value) {
      const idArray = editBodySize?.nut.map((obj: any) => obj.id);
      form.setFieldsValue(Object.assign({ nuts_name: idArray }, editBodySize))
    } else {
      form.resetFields();
    }
  }, [editBodySize, form]);

  const onFinish = (values: any) => {
    
    if (editBodySize?.bodysize_value) {
      let val_arr: any = []

      values.nuts_name.forEach((e: any, i: any) => {
        val_arr.push({ 'bodysize_value': values.bodysize_value, 'nut': e, 'updated_datetime': new Date().toLocaleString() + "" });
      });

      values.updated_datetime = new Date().toLocaleString() + "";
      dispatch(modifyBodySize(val_arr, editBodySize?.bodysize_value));
    } else {
      let val_arr: any = []
      values.nuts_name.forEach((e: any, i: any) => {
        val_arr.push({ 'bodysize_value': values.bodysize_value, 'nut': e, 'created_datetime': new Date().toLocaleString() + "" });
      });

      let data_arr = {
        "bulk": val_arr
      }
      dispatch(addBodySize(data_arr));
    }
    setModelChange(false);
    setEditBodySize(null);
    form.resetFields();
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <Form
      form={form}
      layout={"vertical"}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >
      <Form.Item
        label="Body Size"
        name="bodysize_value"
        rules={[
          {
            required: true,
            message: "Please enter Body Size",
          }
        ]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label="Nut"
        name="nuts_name"
        rules={[
          {
            required: true,
            message: "Please select Nut",
          }
        ]}
      >
        <Select mode="multiple"
          options={nut_array}
        />
      </Form.Item>

      <Form.Item>
        <Button style={{ backgroundColor: '#018B98', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }} type="primary" htmlType="submit" >{editBodySize?.bodysize_value ? 'Update' : 'Create'}</Button>
      </Form.Item>

    </Form>
  );
}
